import { medicalMessages } from './lib/intl/en-US';
import { RecursivePartial } from './lib/types/types';
import { Options } from '@sheerid/jslib';

export const programId = '5e90d96a14a22e1c212db64d';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    useFingerprinting: true,
    logLevel: 'error',
    messagesWithLocale: {
        'en-US': medicalMessages,
    },
};
